<div class="new-contract-container">
<h1>Ablagekorb</h1>
<mat-table  [dataSource]="selected">
  <ng-container matColumnDef="position">
    <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.pos }}</mat-cell>
    <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="sku">
    <mat-header-cell *matHeaderCellDef> Artikelnummer </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.templateId}} </mat-cell>
    <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
    <mat-footer-cell *matFooterCellDef> Gesammtsummen </mat-footer-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="once">
    <mat-header-cell *matHeaderCellDef> Einmalig </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.price | currency}} </mat-cell>
    <mat-footer-cell *matFooterCellDef> {{totalOnce()}} </mat-footer-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="monthly">
    <mat-header-cell *matHeaderCellDef> Monatlich </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.monthly | currency}} </mat-cell>
    <mat-footer-cell *matFooterCellDef> {{totalMonthly()}} </mat-footer-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
    <mat-cell *matCellDef="let element"> <button (click)="remove(element)">Delete</button></mat-cell>
    <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
  </ng-container>


  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let element; columns: displayedColumns;"></mat-row>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</mat-table>

  <div class="d-flex full-width justify-end mt-10">
    <button  matButton="outlined" (click)="save()">Save Contract</button>
    <button (click)="sign()" matButton="filled">Sign Contract</button>
  </div>

</div>
